var React = require('react');

function ArrowLeft (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Symbols","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","strokeLinecap":"round","strokeLinejoin":"round"},React.createElement("g",{"id":"Path-2","stroke":"#2B271F","transform":"translate(5.000000, 5.000000) scale(-1, 1) translate(-5.000000, -5.000000) "},React.createElement("polyline",{"transform":"translate(5.149802, 5.149802) scale(-1, 1) rotate(45.000000) translate(-5.149802, -5.149802) ","points":"2.04960317 2 2 8.29960317 8.29960317 8.25"}))));
}

ArrowLeft.defaultProps = {"viewBox":"0 0 5 11","version":"1.1"};

module.exports = ArrowLeft;

ArrowLeft.default = ArrowLeft;
